export const AddRoleModalConsts = {
  TITLE: "Add Role",
  LABEL: "Role Name",
  PLACEHOLDER: "Enter Role Name",
  FIELD_NAME: "roleName",
  ADD_SUCCESS_MSG: "Role Added Successfully",
  ZINDEX: "2001",
};
